<template>
  <el-row>
    <table-template :queryParams="queryParams" actionUrl="businessIntranet/findBusinessClueCarRecordList.action"
                    ref="intranetClueCarRecordManagerTable">
      <template slot="search">
        <el-row>
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-form-item>
                <el-select  @change="$refs.intranetClueCarRecordManagerTable.search()" clearable placeholder="线索渠道"
                            v-model="queryParams.clueChannelType">
                  <el-option :value="1" label="普通线索"></el-option>
                  <el-option :value="2" label="上汽专区线索"></el-option>
                </el-select>
              </el-form-item>
              <el-select  @change="$refs.intranetClueCarRecordManagerTable.search()" clearable placeholder="收车状态"
                          v-model="queryParams.clueRecordStatus">
                <el-option :value="1" label="正在收车"></el-option>
                <el-option :value="2" label="排队收车"></el-option>
                <el-option :value="3" label="放弃收车"></el-option>
                <el-option :value="4" label="成功收车"></el-option>
                <el-option :value="5" label="锁定看车"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
            <el-select  @change="$refs.intranetClueCarRecordManagerTable.search()" clearable placeholder="申诉状态"
                        v-model="queryParams.appealStatus">
              <el-option :value="1" label="未申诉"></el-option>
              <el-option :value="2" label="申诉中"></el-option>
              <el-option :value="3" label="申诉通过"></el-option>
              <el-option :value="4" label="申诉驳回"></el-option>
            </el-select>
          </el-form-item>

            <el-form-item>
              <el-select clearable  @change="$refs.intranetClueCarRecordManagerTable.search()"  placeholder="申诉理由"
                          v-model="queryParams.appealReason">
                <el-option :value="'无法接通空号'" label="无法接通空号"></el-option>
                <el-option :value="'车主明确不卖车'" label="车主明确不卖车"></el-option>
                <el-option :value="'明确车辆已售'" label="明确车辆已售"></el-option>
                <el-option :value="'明确车商同行'" label="明确车商同行"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-date-picker
                  @change="onDateTimeChange(queryParams.createStartEndTime,1)"
                  end-placeholder="创建结束时间"
                  range-separator="至"
                  start-placeholder="创建开始时间"
                  type="datetimerange"
                  v-model="queryParams.createStartEndTime">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                  @change="onDateTimeChange(queryParams.appealStartEndTime,2)"
                  end-placeholder="申诉结束时间"
                  range-separator="至"
                  start-placeholder="申诉开始时间"
                  type="datetimerange"
                  v-model="queryParams.appealStartEndTime">
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-date-picker
                      @change="onDateTimeChange(queryParams.clueStartEndTime,3)"
                      end-placeholder="发布结束时间"
                      range-separator="至"
                      start-placeholder="发布开始时间"
                      type="datetimerange"
                      clearable="true"
                      v-model="queryParams.clueStartEndTime">
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-date-picker
                      @change="onDateTimeChange(queryParams.dialStartEndTime,4)"
                      end-placeholder="拨打结束时间"
                      range-separator="至"
                      start-placeholder="拨打开始时间"
                      type="datetimerange"
                      clearable="true"
                      v-model="queryParams.dialStartEndTime">
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-input placeholder="收车人电话、车主电话、维护人" style="width:250px;" v-model="queryParams.keyword"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input placeholder="品牌、车系、车型、所在地" style="width:250px;" v-model="queryParams.keywordOne"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="$refs.intranetClueCarRecordManagerTable.search()" type="primary">搜索</el-button>

            </el-form-item>
            <el-form-item>
              <el-button @click="exportExcel()" type="warning">导出</el-button>
            </el-form-item>

          </el-form>
        </el-row>

      </template>
      <template slot="item">
        <el-table-column
            label="收车人"
            >
          <template scope="scope">
            <el-row :gutter="10">
             <el-col >{{ scope.row.recyclerPhone }}<span v-if="scope.row.recyclerName">-{{ scope.row.recyclerName }}</span></el-col>
            </el-row>
            <el-row :gutter="10" v-if="scope.row.maintenanceName">
             <el-col  style="color: red">维护人:{{ scope.row.maintenanceName }}</el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column
            label="收车状态"
            min-width="40px"
            >
          <template scope="scope">
            <el-row :gutter="10">
             <el-col >
               <span :style="scope.row.clueCarRecordStatus==1?'color:#67C23A':scope.row.clueCarRecordStatus==2?'color:#E6A23C':scope.row.clueCarRecordStatus==4?'color:#409EFF':scope.row.clueCarRecordStatus==5?'color:#409EFF':''">{{ scope.row.clueCarRecordStatus|statusFilter }}</span>
             </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column
            label="收车线索"
            min-width="110px"
            >
          <template scope="scope">
            <el-row >
             <el-col >ID:{{ scope.row.clueCarId }} 【{{ scope.row.status |clueCarStatusFilter}}|{{scope.row.channelType|channelTypeFilter}}】</el-col>
            </el-row>
            <el-row >
              <el-col >{{ scope.row.locationCity }}</el-col>
            </el-row>
            <el-row >
             <el-col >{{ scope.row.cluePhone }}<span v-if="scope.row.clueName">-{{ scope.row.clueName }}</span></el-col>
            </el-row>
            <el-row >
             <el-col>{{ scope.row.brand }}</el-col>
             <el-col>{{ scope.row.series }}</el-col>
            </el-row>
            <el-row >
             <el-col >{{ scope.row.category }}</el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column
            label="收车备注"
            >
          <template scope="scope">
            <el-row  v-if="scope.row.quotePrice">
             <el-col  style="color: red" >收车报价:{{ scope.row.quotePrice }}</el-col>
            </el-row>
            <el-row  v-if="scope.row.remark">
             <el-col >{{ scope.row.remark }}</el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column
            label="创建时间"
            width="230px"
            >
          <template scope="scope">
            <el-row>
             <el-col >
               <p>创建时间：{{ scope.row.createTime| dateTimeFormat }}</p>
               <p>发布时间：{{ scope.row.clueCreateTime| dateTimeFormat }}</p>
               <p>维护时间：{{ scope.row.maintenanceLastTime| dateTimeFormat }}</p>
               <p>维护人：{{ scope.row.clueMaintenanceName }}</p>

             </el-col>
            </el-row>
            <el-row v-if="scope.row.recordMaintenanceName">
             <el-col  style="color: red">记录人:{{ scope.row.recordMaintenanceName }}</el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column
            label="线索拨打/申诉"
            min-width="110px"
            >
          <template scope="scope">
            <el-row >
              <el-col >拨打时间:{{ scope.row.callTime| dateTimeFormat }}</el-col>
            </el-row>
            <el-row >
              <el-col >申诉时间:{{ scope.row.appealApplyTime| dateTimeFormat }}</el-col>
            </el-row>
            <el-row >
              <el-col >处理时间:{{ scope.row.appealHandleTime| dateTimeFormat }}</el-col>
            </el-row>
            <el-row  >
              <el-col  >申诉状态:<span :style="scope.row.appealStatus==2?'color:#E6A23C':scope.row.appealStatus==3?'color:#67C23A':scope.row.appealStatus==4?'color:#F56C6C':''">{{ scope.row.appealStatus|appealStatusFilter }}</span></el-col>
            </el-row>
            <el-row  >
              <el-col  >申诉理由:{{scope.row.appealReason}}</el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column
            label="审核备注"
            prop="appealHandleRemark">

        </el-table-column>

        <el-table-column
            label="操作">
          <template scope="scope">
            <el-button type="text" @click.native.prevent="$router.push({path:'/home/intranetClueCarRecordItem', query: { id: scope.row.clueCarRecordId }})"  size="mini">
              修改
            </el-button>
            <el-button type="text" v-if="scope.row.canAppeal==1" @click.native.prevent="$router.push({path:'/home/authClueCarRecord', query: { id: scope.row.clueCarRecordId }})"  size="mini">
              申诉审核
            </el-button>
          </template>
        </el-table-column>
      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'intranetClueCarRecordManager',
  data: function () {
    return {
      queryParams: {
        clueRecordStatus: null,
        createStartEndTime: null,
        appealStartEndTime: null,
        clueStartEndTime: null,
        dialStartEndTime: null,
        appealStatus: 2,
        clueChannelType: null,
        keyword: null,
        keywordOne: null,
        appealReason: null

      }
    }
  },
  watch: {
    'queryParams.clueRecordStatus': function (val) {
      if (val === '') {
        this.queryParams.clueRecordStatus = null
      }
    },
    'queryParams.appealStatus': function (val) {
      if (val === '') {
        this.queryParams.appealStatus = null
      }
    }
  },
  methods: {
    exportExcel: function () {
      let _this = this

      let dataStr = ''

      if (this.queryParams.clueRecordStatus) {
        dataStr += '&clueRecordStatus=' + this.queryParams.clueRecordStatus
      }
      if (this.queryParams.createStartTime) {
        dataStr += '&createStartTime=' + this.queryParams.createStartTime
      }
      if (this.queryParams.createEndTime) {
        dataStr += '&createEndTime=' + this.queryParams.createEndTime
      }

      if (this.queryParams.startAppealTime) {
        dataStr += '&startAppealTime=' + this.queryParams.startAppealTime
      }

      if (this.queryParams.endAppealTime) {
        dataStr += '&endAppealTime=' + this.queryParams.endAppealTime
      }

      if (this.queryParams.startClueTime) {
        dataStr += '&startClueTime=' + this.queryParams.startClueTime
      }

      if (this.queryParams.endClueTime) {
        dataStr += '&endClueTime=' + this.queryParams.endClueTime
      }

      if (this.queryParams.startDialTime) {
        dataStr += '&startDialTime=' + this.queryParams.startDialTime
      }

      if (this.queryParams.endDialTime) {
        dataStr += '&endDialTime=' + this.queryParams.endDialTime
      }

      if (this.queryParams.appealReason) {
        dataStr += '&appealReason=' + this.queryParams.appealReason
      }

      if (this.queryParams.appealStatus) {
        dataStr += '&appealStatus=' + this.queryParams.appealStatus
      }
      if (this.queryParams.clueChannelType) {
        dataStr += '&clueChannelType=' + this.queryParams.clueChannelType
      }
      if (this.queryParams.keyword) {
        dataStr += '&keyword=' + this.queryParams.keyword
      }
      if (this.queryParams.keywordOne) {
        dataStr += '&keywordOne=' + this.queryParams.keywordOne
      }

      let userInfo = _this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }
      window.location.href = Config.baseUrl + 'businessIntranet/findBusinessClueCarRecordListExcel.action?' + 'token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath + dataStr
    },
    onDateTimeChange (dates, type) {
      switch (type) {
        case 1:
          if (dates && dates.length === 2) {
            this.queryParams.createStartTime = dates[0].getTime()
            this.queryParams.createEndTime = dates[1].getTime()
          } else {
            this.queryParams.createStartTime = null
            this.queryParams.createEndTime = null
          }
          break
        case 2:
          if (dates && dates.length === 2) {
            this.queryParams.startAppealTime = dates[0].getTime()
            this.queryParams.endAppealTime = dates[1].getTime()
          } else {
            this.queryParams.startAppealTime = null
            this.queryParams.endAppealTime = null
          }
          break
        case 3:
          if (dates && dates.length === 2) {
            this.queryParams.startClueTime = dates[0].getTime()
            this.queryParams.endClueTime = dates[1].getTime()
          } else {
            this.queryParams.startClueTime = null
            this.queryParams.endClueTime = null
          }
          break
        case 4:
          if (dates && dates.length === 2) {
            this.queryParams.startDialTime = dates[0].getTime()
            this.queryParams.endDialTime = dates[1].getTime()
          } else {
            this.queryParams.startDialTime = null
            this.queryParams.endDialTime = null
          }
          break
      }

      this.$refs.intranetClueCarRecordManagerTable.search()
    }
  },
  filters: {
    statusFilter: function (val) {
      let str = '非法值'
      switch (val) {
        case 1:
          str = '正在收车'
          break
        case 2:
          str = '排队收车'
          break
        case 3:
          str = '放弃收车'
          break
        case 4:
          str = '成功收车'
          break
        case 5:
          str = '锁定看车'
          break
      }
      return str
    },
    appealStatusFilter: function (val) {
      let str = '非法值'
      switch (val) {
        case 1:
          str = '未申诉'
          break
        case 2:
          str = '申诉中'
          break
        case 3:
          str = '申诉通过'
          break
        case 4:
          str = '申诉驳回'
          break
      }
      return str
    },
    channelTypeFilter: function (val) {
      let str = '非法值'
      switch (val) {
        case 1:
          str = '普通线索'
          break
        case 2:
          str = '上汽专区'
          break
        case 3:
          str = '先锋专区'
          break
        case 4:
          str = '汽车网专区'
          break
      }
      return str
    },
    clueCarStatusFilter: function (val) {
      let str = '非法值'
      switch (val) {
        case 1:
          str = '有效线索'
          break
        case 2:
          str = '成功收车'
          break
        case 3:
          str = '无效线索'
          break
        case 4:
          str = '待清洗'
          break
        case 5:
          str = '清洗中'
          break
        case 6:
          str = '审核中'
          break
      }
      return str
    }
  }
}
</script>

<style scoped>
</style>
